const DEFAULT_KEY_NAME: string = "現場No";

export default DEFAULT_KEY_NAME;
